import React from 'react';
import { Menu, Container, Divider } from 'semantic-ui-react';

const d = new Date();

const Footer = () => (
	<Container>
		<Divider />
		<Menu secondary style={{marginBottom: "12px"}}>
			<Menu.Item fitted="horizontally">&copy; The Roseland Institute { d.getFullYear() }</Menu.Item>
			<Menu.Item position="right" fitted="horizontally" link href="http://cadmia.io">Built by Cadmia LTD</Menu.Item>
		</Menu>
	</Container>
)

export default Footer;


// WEBPACK FOOTER //
// ./src/components/Footer.js